import React, { useEffect, useState } from "react";
import Main from "./Main";
import { useSelector } from "react-redux";
import { registerMerchant } from "../api/userAuth";
import { ROLE_CREATE_PERMISSION } from "../features/rolesTabel";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { useNotify } from "../context/NotifyContext";
import { CompactSelect } from "../components/listing";

const Registration = () => {
  const [formData, setFormData] = useState({
    merchantType: "",
    name: "",
    email: "",
    mobile: "",
  });

  const [roles, setRoles] = useState([]);
  const { userInfo } = useSelector((state) => state?.auth);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { notify } = useNotify();

  useEffect(() => {
    const allowedRole = ROLE_CREATE_PERMISSION[userInfo?.role] || [];
    setRoles(allowedRole);
  }, [userInfo?.role]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "mobile" && !/^\d*$/.test(value)) return;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { merchantType, name, email, mobile } = formData;

    if (!merchantType.trim()) return notify("Please select merchant type", "error");
    if (!name.trim()) return notify("Name is required", "error");
    if (!email.trim()) return notify("Email is required", "error");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
      return notify("Invalid email format", "error");
    if (!mobile.trim()) return notify("Mobile number is required", "error");
    if (!/^\d{10}$/.test(mobile)) return notify("Mobile number must be 10 digits", "error");

    setLoading(true);
    try {
      const payload = {
        role: merchantType,
        name: name.trim(),
        email: email.trim(),
        phone: mobile.trim(),
      };

      const data = await registerMerchant(payload);

      if (data?.success) {
        notify(data.message || "Merchant registered successfully!", "success");
        setFormData({ merchantType: "", name: "", email: "", mobile: "" });
        const user = data?.data?.user;
        if (user?.userName) navigate(`/merchant/${user.userName}`);
      } else {
        notify(data?.message || "Failed to register merchant", "error");
      }
    } catch (err) {
      notify("Server error. Please try again", "error");
    } finally {
      setLoading(false);
    }
  };

  const roleOptions = roles.map((role) => ({ value: role, label: role }));
  const introducerOptions = userInfo?.userName
    ? [
        {
          value: userInfo.userName,
          label: `${userInfo.userName} JSS MANAGEMENT AND SUPPLY`,
        },
      ]
    : [];

  return (
    <Main showRightPanel>
      <div className="flex flex-col items-stretch w-full max-w-full min-w-0 overflow-x-hidden">
        <div className="ds-card p-4 w-full max-w-md mx-auto sm:mx-0">
          <h2 className="text-[15px] font-semibold text-[var(--text-dark)] mb-4">
            Merchant Registration - Basic Details
          </h2>

          <form className="space-y-3.5" onSubmit={handleSubmit}>
            <div>
              <label className="ds-label">
                Merchant Type <span className="text-[var(--error-color)]">*</span>
              </label>
              <CompactSelect
                className="w-full"
                value={formData.merchantType}
                onChange={(v) =>
                  setFormData((prev) => ({ ...prev, merchantType: v }))
                }
                options={roleOptions}
                placeholder="Select Merchant Type"
                ariaLabel="Merchant Type"
              />
            </div>

            <div>
              <label className="ds-label">
                Introducer Merchant <span className="text-[var(--error-color)]">*</span>
              </label>
              <CompactSelect
                className="w-full"
                value={formData.name}
                onChange={(v) => setFormData((prev) => ({ ...prev, name: v }))}
                options={introducerOptions}
                placeholder="Select Introducer"
                ariaLabel="Introducer Merchant"
              />
            </div>

            <div>
              <label className="ds-label">
                Email Address <span className="text-[var(--error-color)]">*</span>
              </label>
              <input
                type="email"
                name="email"
                placeholder="example@gmail.com"
                value={formData.email}
                onChange={handleChange}
                className="ds-input text-sm"
              />
            </div>

            <div>
              <label className="ds-label">
                Mobile Number <span className="text-[var(--error-color)]">*</span>
              </label>
              <input
                type="text"
                name="mobile"
                value={formData.mobile}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  if (value.length <= 12) {
                    handleChange({ target: { name: "mobile", value } });
                  }
                }}
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={12}
                placeholder="Enter mobile number"
                className="ds-input text-sm"
              />
            </div>

            <div className="ds-form-actions">
              <button
                type="submit"
                disabled={loading}
                className="ds-btn ds-btn-primary"
              >
                {loading ? (
                  <span className="inline-flex items-center gap-2">
                    Processing...
                    <CircularProgress size={14} sx={{ color: "inherit" }} />
                  </span>
                ) : (
                  "Proceed To Next"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Main>
  );
};

export default Registration;
